import { render, staticRenderFns } from "./AdminRevenueTab.vue?vue&type=template&id=4e62f771&scoped=true"
import script from "./AdminRevenueTab.vue?vue&type=script&lang=js"
export * from "./AdminRevenueTab.vue?vue&type=script&lang=js"
import style0 from "./AdminRevenueTab.vue?vue&type=style&index=0&id=4e62f771&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e62f771",
  null
  
)

export default component.exports